import { useCookies } from "react-cookie";
import Header from "../../Components/Header/Header";
import CreateTrainingSessionForm from "./CreateTrainingSessionForm";
import "./CreateTrainingSession.css";

// Standalone create-session page (also embedded inline in the Antrenare tab).
const CreateTrainingSession = ({ data, socket } : { data: any, socket: any }) => {
    const [cookies] = useCookies();
    const en = cookies?.language === "en";

    return (
        <div className="content">
            <Header data={data} socket={socket} />
            <h2 className="title" style={{ textAlign: "center" }}>{en ? "Create training session" : "Creează sesiune de antrenament"}</h2>
            <CreateTrainingSessionForm data={data} />
        </div>
    );
};

export default CreateTrainingSession;
